export default {
    AWS_MARKET_PLACE: 'AWS_MARKET_PLACE',
    ZUORA: 'ZUORA',
};
